import dayjs from 'dayjs'
import { ComposerTranslation } from 'vue-i18n'
import {
  VyzvaPublicDetailStavEnum,
  MonitorovanyUkazovatelPublicResponseTypEnum,
} from '/@src/client-public'
import { isEntityActive } from '/@src/composable/useSubjekt'
import { DATE_FORMAT, DATETIME_FORMAT } from '/@src/constants'
import {
  Adresa,
  CiselnikBasicResponse,
  OsobaOrganizacieZaradenieZaradenieEnum,
  ProjektRozpocetFinancovanieZdrojFinancovaniaEnum,
} from '/@src/client-portal'
import xss from 'xss'

export function formatTituly(
  titulyIds: string[] | object[] = [],
  titulyCiselnik: CiselnikBasicResponse[],
  emptyValue: string = ''
) {
  if (typeof titulyIds[0] === 'string') {
    return (
      titulyIds
        ?.map(
          (titulId) => titulyCiselnik.find(({ kodZdroj }) => titulId === kodZdroj)?.nazov
        )
        ?.join(', ') ?? ''
    )
  } else if (typeof titulyIds[0] === 'object') {
    return titulyIds?.map(({ nazov }) => nazov)?.join(', ') ?? ''
  }
  return emptyValue
}

export function formatZaradenia(
  zaradenia: { zaradenie: OsobaOrganizacieZaradenieZaradenieEnum }[] = [],
  t: ComposerTranslation
) {
  return (
    zaradenia
      ?.filter(isEntityActive)
      ?.map(({ zaradenie }) => t(`subjekt.zaradenia.${zaradenie}`))
      ?.join(', ') ?? ''
  )
}

export function formatDateTimeString(date: string | undefined, defaultEmpty = '') {
  return date ? dayjs(date).format(DATETIME_FORMAT) : defaultEmpty
}

export function formatDateString(date: string | undefined, defaultEmpty = '') {
  return date ? dayjs(date).format(DATE_FORMAT) : defaultEmpty
}

// TODO: vymazať keď bude biznis stav v modeli a nekonvertovať stav na biznisStav
const convertStavToBiznisStav = (stav: string) => {
  return (
    {
      PRIJATA: 'ZAEVIDOVANA_ISPO',
    }[stav] ?? stav
  )
}

export function formatZiadostStav(stav: string) {
  const biznisStav = convertStavToBiznisStav(stav)

  return {
    ROZPRACOVANA: 'Rozpracovaná',
    SFINALIZOVANA: 'Sfinalizovaná',
    ZAEVIDOVANA_ISPO: 'Zaevidovaná v ISPO',
    PREDLOZENA: 'Predložená',
    STORNOVANA: 'Stornovaná',
    ZAMIETNUTA: 'Zamietnutá',
  }[biznisStav]
}

export function formatUkazovatel(typ: string) {
  return {
    [MonitorovanyUkazovatelPublicResponseTypEnum.Kvalitativny]: 'Kvalitatívny',
    [MonitorovanyUkazovatelPublicResponseTypEnum.Kvantitativny]: 'Kvantitatívny',
  }[typ]
}

export function formatVyzvaStav(stav: string) {
  return {
    [VyzvaPublicDetailStavEnum.Nova]: 'Nová',
    [VyzvaPublicDetailStavEnum.VPriprave]: 'V príprave',
    [VyzvaPublicDetailStavEnum.KontrolaNika]: 'Kontrola NIKA',
    [VyzvaPublicDetailStavEnum.NaDoplnenie]: 'Na doplnenie',
    [VyzvaPublicDetailStavEnum.KontrolaUkoncena]: 'Kontrola ukončená',
    [VyzvaPublicDetailStavEnum.Zverejnena]: 'Zverejnená',
    [VyzvaPublicDetailStavEnum.Pozastavena]: 'Pozastavená',
    [VyzvaPublicDetailStavEnum.Uzatvorena]: 'Uzatvorená',
    [VyzvaPublicDetailStavEnum.RegistraciaZrusena]: 'Registrácia zrušená',
    [VyzvaPublicDetailStavEnum.Zrusena]: 'Zrušená',
  }[stav]
}

export function formatZdrojFinancovaniaZhrnutie(stav: string) {
  return {
    [ProjektRozpocetFinancovanieZdrojFinancovaniaEnum.Poo]: 'Suma z Plánu obnovy bez DPH',
    [ProjektRozpocetFinancovanieZdrojFinancovaniaEnum.Poo + '_DPH']:
      'Čiastka DPH z plánu obnovy',
    [ProjektRozpocetFinancovanieZdrojFinancovaniaEnum.VlastneZdroje]:
      'Vlastné zdroje žiadateľa (tzn. súkromné; ak sú vlastné zdroje verejné zdroje, tak sa uvádzajú do verejných)',
    [ProjektRozpocetFinancovanieZdrojFinancovaniaEnum.StatnyRozpocet]:
      'Verejné zdroje okrem zdrojov EÚ (napr. štátny rozpočet, výdavky VÚC)',
    [ProjektRozpocetFinancovanieZdrojFinancovaniaEnum.IneZdroje]: 'Verejné zdroje EÚ',
  }[stav]
}

export function formatAdresa(adresa: Adresa) {
  return [
    `${adresa.ulica ? `${typeof adresa.ulica === 'object' ? adresa.ulica.id : adresa.ulica} ` : ''}${adresa.supisneCislo}${adresa.orientacneCislo ? `/${adresa.orientacneCislo}` : ''
    }, ${typeof adresa.psc === 'object' ? adresa.psc.id : adresa.psc} ${adresa.obec?.nazov ?? adresa.obec ?? ''},`,
    `${adresa.kraj?.nazov ?? adresa.kraj ?? ''}${adresa.kraj?.nazov || adresa.kraj ? ',' : ''} ${adresa.stat?.nazov ?? adresa.stat ?? ''
    }`,
  ]
}

export function newLineToLineBreak(s: string) {
  return xss(s)?.replace(/\n/g, '<br>')
}

export const formatNumberInput = (value: string) => {
  const replacedVal = value.replaceAll(',', '.')
  return replacedVal
}
